module.exports = __webpack_public_path__ + "static/media/stemlogo.66170290.png";